import { render, staticRenderFns } from "./PropertiesSold.vue?vue&type=template&id=6f298b7c&scoped=true&"
import script from "./PropertiesSold.vue?vue&type=script&lang=ts&"
export * from "./PropertiesSold.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f298b7c",
  null
  
)

export default component.exports